import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import AddButton from "components/ui/Button/AddButton/AddButton";
import { baseResources, baseResourceActions } from "routes/enum";

const { KB_AGENT_GUIDE_SCENARIO } = baseResources;
const { UPDATE } = baseResourceActions;

const EditScenarioButton = ({ onClick }) => {
    return (
        <div>
            <ComponentAccessControl
                baseResources={[`${UPDATE}_${KB_AGENT_GUIDE_SCENARIO}`]}>
                <AddButton btnText={`Edit`} hasIcon={false} onClick={onClick} />
            </ComponentAccessControl>
        </div>
    );
};

export default EditScenarioButton;
